import { render, staticRenderFns } from "./toutiaoForm.vue?vue&type=template&id=686180ae&scoped=true&"
import script from "./toutiaoForm.vue?vue&type=script&lang=js&"
export * from "./toutiaoForm.vue?vue&type=script&lang=js&"
import style0 from "./toutiaoForm.vue?vue&type=style&index=0&id=686180ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686180ae",
  null
  
)

export default component.exports